import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import SignUp_first_step_New from "./Signup_First_step_New";
import SignUp_second_step_New from "./Signup_Second_step_New";
import Success_signup from "./Success_signup";
import { userService } from "../../_services";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Loader2, Phone, Mail, Play } from 'lucide-react';
import Logo from "../../images/logo.png";
import SignupBg from "../../images/signup_bg.webp";
import mobile_login_bg from "../../images/signup_bg.png";
import CardFront from "../../images/NLSRX_round_corner_front.jpg";
import CardBack from "../../images/NLSRX_round_corner_back.jpg";
import VideoPlayBtn from "../../images/video_play_btn.png";
import SignupVideoBg from "../../images/signup_video_bg.webp";
import { cn } from "@/lib/utils";

const SignUp = () => {
    const [signupStep, setSignupStep] = useState('1st');
    const [step1Data, setStep1Data] = useState(null);
    const [faqData, setFaqData] = useState([]);
    const [videoPlaying, setVideoPlaying] = useState(false);
    const [supportEmail, setSupportEmail] = useState('support@nulifespanrx.com'); // Default fallback
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [secLinkUser, setSecLinkUser] = useState(false);
    const [redirectErr, setRedirectErr] = useState(false);

    useEffect(() => {
        // Get support email from client-side logic (no API call needed!)
        // getemail() is now synchronous and returns email based on environment
        const email = userService.getemail();
        setSupportEmail(email);
        
        secondaryLinkVerify();
    }, []);

    // Build FAQ data when supportEmail is available
    useEffect(() => {
        const faqList = [
            {
                question: "Is this really FREE?",
                answer: "Yes absolutely no cost to you now or ever. Not only do other companies pay you less but they charge you an initiation and monthly fee. We think that is outrageous."
            },
            {
                question: "Why is it that agents in the NuLifeSpan Rx Distributor program make more money than anyone else in the industry?",
                answer: "Our goal was to get our discount card spread nationwide. To accomplish that, we have to pay our reps the most in the industry and our card has to provide the greatest discount. We study and research every possible way to get our reps making the most money possible. There are no secrets – you get all the information that our top reps making $10k+ per month get."
            },
            {
                question: "How much money can I make?",
                answer: "We have people making anywhere from a few hundred dollars per month to over $10k+ per month. You will earn a competitive commission anytime someone uses your card to pick up a prescription."
            },
            {
                question: "How and when do I get paid?",
                answer: "You get paid every month through PayQuicker. You can elect to get a check mailed to you, get direct deposit into your bank account, or have a personal debit card mailed to you that contains your funds. Payments are made monthly for the previous month's transactions."
            },
            {
                question: "Can I offer a doctor, pharmacist or other health care worker or pharmacy employee money or gifts to promote the NuLifeSpan Rx Program?",
                answer: "No! Absolutely not."
            },
            {
                question: "Can I get a doctor, pharmacist or other health care worker or pharmacy employee to become an affiliate of the NuLifeSpan Rx Program?",
                answer: "No! No doctor, nurse, pharmacist, pharmacy intern or tech, or any other health care employee can serve as a marketer of the NuLifeSpan Rx Program."
            },
            {
                question: "What if a doctor, pharmacist, healthcare worker or pharmacy employee asks me for payment in exchange for promoting the NuLifeSpan Rx Program?",
                answer: `Politely decline and make it clear that such arrangements are against company policy. You should report such requests to ${supportEmail}. If you would prefer to make a confidential, anonymous report, you can use one of these reporting options: Website: www.lighthouse-services.com/rxhacker or Toll-Free Telephone: English speaking: 833-222-2698, Spanish speaking: 800-216-1288`
            },
            {
                question: "Do I have to get NuLifeSpan Rx's approval of my web site or social media posts?",
                answer: "Yes! In order for us to ensure our marketing network complies with all applicable federal, state and local regulations, we require every marketer – and every contractor of every marketer – to submit their marketing materials – which includes, for example, your web site, social media posts, and marketing emails. Failure to do so will subject your contract to immediate termination."
            },
            {
                question: "What if I forget to get pre-approval of my social media or other online posts?",
                answer: "You must immediately delete any such posts (whether inadvertent or not) and submit such inappropriately posted marketing material to NuLifeSpan Rx for review and approval."
            },
            {
                question: "What if one of my subcontractors uses marketing material that they did not submit for pre-approval?",
                answer: "If you learn that one of your contractors has failed to secure pre-approval of their marketing material, you must immediately (1) cause that contractor to cease immediately the use of any such material and (2) report the same to NuLifeSpan Rx – together with the unapproved marketing materials – for review. Any marketer – and any subcontractor of any marketer – is subject to immediate termination for failure to have your marketing material pre-approved by NuLifeSpan Rx."
            },
            {
                question: "What if a pharmacist or other pharmacy employee asks me or a member of my team for a referral fee or some other payment or gift in connection with the NuLifeSpan Rx Program?",
                answer: `You must report any such request – or even the suggestion of such a request – immediately to ${supportEmail}. If you would prefer to make a confidential, anonymous report, you can use one of these reporting options: Website: www.lighthouse-services.com/rxhacker or Toll-Free Telephone: English speaking: 833-222-2698, Spanish speaking: 800-216-1288`
            },
            {
                question: "What if I have concerns that someone is out there distributing the NuLifeSpan Rx Program in violation of NuLifeSpan Rx's compliance standards?",
                answer: `If you have any such concerns, please contact ${supportEmail} immediately so that we can address the situation as soon as possible. If you would prefer to make a confidential, anonymous report, you can use one of these reporting options: Website: www.lighthouse-services.com/rxhacker or Toll-Free Telephone: English speaking: 833-222-2698, Spanish speaking: 800-216-1288`
            },
            {
                question: "What if I have questions about compliance or about what marketing activities I can engage in?",
                answer: `If you have any such questions, please contact your customer success manager, who can direct your questions to the appropriate NuLifeSpan Rx professional. Of course, you can always reach out to ${supportEmail} as well.`
            }
        ];
        setFaqData(faqList);
    }, [supportEmail]);

    const secondaryLinkVerify = () => {
        let linkSuffix = window.location.href;
        if (linkSuffix.includes('/signup')) {
            let text = window.location.pathname;
            let pattern = /\/signup\/[0-9a-zA-Z]/g;
            let refpattern = /\/signup\/ref\/[0-9a-zA-Z]/g;
            try {
                if (pattern.test(text) && !refpattern.test(text)) {
                    userService.ValidateSecondLink('0', '', linkSuffix)
                        .then(apidata => {
                            if (apidata[0].statusCode === 1) {
                                setSecLinkUser(true);
                                setRedirectErr(false);
                                localStorage.setItem('ReferralURL', linkSuffix);
                            } else {
                                setSecLinkUser(false);
                                setRedirectErr(true);
                            }
                        });
                }
            } catch (error) {
                console.error('Secondary link verification error:', error);
            }
        }
    };

    const validateForm = () => {
        const newErrors = { name: '', email: '', message: '' };
        let isValid = true;

        if (formData.name.length < 3) {
            newErrors.name = 'Name must be at least 3 characters long';
            isValid = false;
        }
        if (formData.message.length < 15) {
            newErrors.message = 'Message must be at least 15 characters long';
            isValid = false;
        }
        if (formData.email.length < 1) {
            newErrors.email = "Enter your email";
            isValid = false;
        } else if (!userService.ValidEmailRegex(formData.email)) {
            newErrors.email = 'Invalid Email';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmitQuestion = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        try {
            const apiData = await userService.SubmitQuestion(
                formData.name,
                formData.email,
                formData.message
            );

            if (apiData.length > 0) {
                setFormData({ name: '', email: '', message: '' });
                setSuccessMsg(apiData[0].message);
                setTimeout(() => setSuccessMsg(''), 3000);
            }
        } catch (error) {
            console.error('Submit question error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleStep1Complete = (data) => {
        setStep1Data(data);
        setSignupStep('2nd');
        scrollToTop();
    };

    const playVideo = (e) => {
        setVideoPlaying(true);
    };

    // Check if user is already logged in and redirect accordingly
    if (!userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        const userType = window.atob(localStorage.getItem('_Host_Pro_type'));
        if (userType === "Admin") {
            return <Navigate to="/Admin/groups" replace />;
        } else if (userType === "consumer") {
            return <Navigate to="/consumer/Summary" replace />;
        } else {
            return <Navigate to="/summary" replace />;
        }
    }

    if (redirectErr) {
        return <Navigate to="/page-not-found" replace />;
    }

    return (
        <div className="min-h-screen bg-secondary">
            {/* Signup Form Section */}
            <div className="w-full mx-auto">
                <div className="grid lg:grid-cols-2 gap-8 mx-auto">
                    {/* Left side - Logo + Signup Form (Step 1, 2, or Success) */}
                    <div className="w-full lg:mx-0 px-4 ps-12">
                        {/* Logo */}
                        <div className="flex justify-start mb-8 pt-6">
                            <img 
                                src={Logo} 
                                alt="NuLifeSpan Rx Logo" 
                                className="h-8 lg:h-9 object-contain"
                            />
                        </div>
                        
                        {/* Form */}
                        {signupStep === '1st' ? (
                            <SignUp_first_step_New isSecUser={secLinkUser} onNext={handleStep1Complete} />
                        ) : signupStep === '2nd' ? (
                            <SignUp_second_step_New isSecUser={secLinkUser} />
                        ) : signupStep === 'Done' ? (
                            <Success_signup />
                        ) : null}
                    </div>

                    {/* Right side - Image */}
                    <div className="hidden lg:flex flex-col items-center justify-center">
                        <img
                            src={SignupBg}
                            alt="Sign Up"
                            className="w-full aspect-square object-cover"
                        />
                    </div>
                </div>
            </div>

            {/* Video Section */}
            <div className="bg-white">
                <div className="container mx-auto px-4 py-16">
                    <div className="grid lg:grid-cols-2 gap-8 items-center max-w-6xl mx-auto">
                        {/* Video Player */}
                        <div className="relative rounded-lg overflow-hidden aspect-video group cursor-pointer">
                            {!videoPlaying ? (
                                <>
                                    {/* Background Image */}
                                    <img 
                                        src={SignupVideoBg} 
                                        alt="Video Background" 
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                    />
                                    {/* Play Button Overlay */}
                                    <div
                                        onClick={playVideo}
                                        className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/20 transition-colors"
                                    >
                                        <div className="bg-white rounded-full p-4 opacity-90 group-hover:opacity-100 transition-opacity shadow-lg">
                                            <Play className="h-10 w-10 text-brand-accent" />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <iframe
                                    className="w-full h-full"
                                    src="https://www.youtube.com/embed/RryTwk5OD_c?autoplay=1&rel=0"
                                    allowFullScreen
                                    title="Program Video"
                                    allow="autoplay"
                                ></iframe>
                            )}
                        </div>

                        {/* Video Content */}
                        <div className="space-y-4">
                        <p className="text-accent font-semibold">Watch and Learn about our program</p>
                        <h2 className="text-4xl font-bold text-foreground mb-4">
                            Helping people save money has never been so profitable
                        </h2>
                        <p className="text-xl text-foreground opacity-70">
                            Sign up now to be an affiliate and start down the path to financial freedom.
                        </p>
                        <Button size="lg" onClick={scrollToTop} className="bg-accent hover:bg-accent/90 text-white w-auto">
                            Sign up Today!
                        </Button>
                    </div>
                </div>
            </div>
            </div>

            {/* FAQ Section */}
            {!secLinkUser && (
                <div className="bg-secondary">
                    <div className="container mx-auto px-4 py-16">
                        <div className="max-w-4xl mx-auto text-center mb-8">
                            <h2 className="text-4xl font-bold text-foreground mb-4">
                                Frequently Asked Questions
                            </h2>
                            <p className="text-xl text-foreground opacity-70">
                                You've got questions? We've got answers!
                            </p>
                        </div>

                        <div className="max-w-4xl mx-auto">
                            <Accordion type="single" collapsible className="space-y-4">
                                {faqData.map((faq, index) => (
                                    <AccordionItem
                                        key={index}
                                        value={`item-${index}`}
                                        className="bg-white shadow-md rounded-lg  px-6 data-[state=open]:border-accent"
                                    >
                                        <AccordionTrigger className="text-left font-semibold hover:no-underline py-4">
                                            {faq.question}
                                        </AccordionTrigger>
                                        <AccordionContent className="text-foreground opacity-70 pb-4">
                                            {faq.answer}
                                        </AccordionContent>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        </div>

                        <div className="text-center mt-12">
                            <Button size="lg" onClick={scrollToTop} className="bg-accent hover:bg-accent/90 text-white w-auto">
                                Signup Today!
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            {/* Discount Cards Section */}
            <div className="bg-white py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-4xl font-bold text-foreground mb-8 text-center">
                        Save on Prescriptions
                    </h2>
                    <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-6 px-4">
                        {/* Card Front */}
                        <div className="bg-white rounded-lg shadow-[0_1px_7px_0_rgba(139,166,193,0.07)] overflow-hidden">
                            <img
                                src={CardFront}
                                alt="NuLifeSpan Rx Discount Card Front"
                                className="w-full h-auto"
                            />
                        </div>
                        {/* Card Back */}
                        <div className="bg-white rounded-lg shadow-[0_1px_7px_0_rgba(139,166,193,0.07)] overflow-hidden">
                            <img
                                src={CardBack}
                                alt="NuLifeSpan Rx Discount Card Back"
                                className="w-full h-auto"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Form Section */}
            <div className="bg-secondary py-16">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto">
                        <div className="text-center mb-8">
                            <h2 className="text-4xl font-bold text-foreground mb-4">Still Have Questions?</h2>
                            <p className="text-xl text-foreground opacity-70">
                                Need more info? No problem! Just reach out to us using this contact form
                            </p>
                        </div>

                        {/* Form */}
                        <div className="bg-white rounded-lg shadow-md p-8">
                            <form onSubmit={handleSubmitQuestion} className="space-y-4">
                                <div className="grid md:grid-cols-2 gap-6">
                                    {/* Left Column - Name and Email */}
                                    <div className="space-y-4 grid grid-cols-1 justify-between">
                                        <div className="relative">
                                            <Input
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                className={cn("peer h-12 mb-0", errors.name && "border-red-500")}
                                                disabled={isLoading}
                                                placeholder=" "
                                            />
                                            <Label htmlFor="name" className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                                Name
                                            </Label>
                                            {errors.name && (
                                                <p className="text-sm text-red-500 mt-1">{errors.name}</p>
                                            )}
                                        </div>
                                        <div className="relative">
                                            <Input
                                                id="email"
                                                name="email"
                                                type="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                className={cn("peer h-12 mb-0", errors.email && "border-red-500")}
                                                disabled={isLoading}
                                                placeholder=" "
                                            />
                                            <Label htmlFor="email" className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                                Email
                                            </Label>
                                            {errors.email && (
                                                <p className="text-sm text-red-500 mt-1">{errors.email}</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Right Column - Textarea */}
                                    <div className="relative">
                                        <Textarea
                                            id="message"
                                            name="message"
                                            rows={5}
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            className={cn("peer", errors.message && "border-red-500")}
                                            disabled={isLoading}
                                            placeholder=" "
                                        />
                                        <Label htmlFor="message" className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground">
                                            Your Message
                                        </Label>
                                        {errors.message && (
                                            <p className="text-sm text-red-500 mt-1">{errors.message}</p>
                                        )}
                                    </div>
                                </div>

                                {successMsg && (
                                    <div className="bg-green-50 border border-green-200 rounded-md p-4 text-green-800">
                                        {successMsg}
                                    </div>
                                )}

                                <div className="flex justify-center">
                                    <Button type="submit" className="bg-accent hover:bg-accent/90 text-white w-auto" size="lg" disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                                Sending...
                                            </>
                                        ) : (
                                            'Submit'
                                        )}
                                    </Button>
                                </div>
                            </form>
                        </div>

                        {/* Contact Info */}
                        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-8">
                            <div className="flex items-center gap-2 text-foreground">
                                <Phone className="h-5 w-5 text-accent" />
                                <span className="font-medium">(877)787-9372</span>
                            </div>
                            <div className="flex items-center gap-2 text-foreground">
                                <Mail className="h-5 w-5 text-accent" />
                                <span className="font-medium">{supportEmail}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-secondary border-t border-slate-200 py-8">
                <div className="container mx-auto px-4 text-center text-sm text-foreground opacity-70">
                    <div className="mb-2">
                        <a href="/terms" className="hover:text-accent">Terms</a>
                        <span className="mx-2">|</span>
                        <a href="https://nulifespanrx.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-accent">
                            Privacy
                        </a>
                    </div>
                    <div>
                        Copyright © {new Date().getFullYear()} NuLifeSpan Rx. All rights reserved.
                    </div>
                </div>
            </footer>

            {/* Mobile background image */}
            <div className="fixed inset-0 -z-10 lg:hidden">
                <img
                    src={mobile_login_bg}
                    alt=""
                    className="w-full h-full object-cover opacity-10"
                />
            </div>
        </div>
    );
};

export default SignUp;
